/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
 *      1       | 23/11/2023 | Lic. José Luis Aragón Cervantes  | Creación
 *      2       | 10/10/2026 | Lic. José Luis Aragón Cervantes  | Accesos rápidos del dashboard central (planeta)
 * ---------------------------------------------------------------------------------------
 */

//Iconos
import SecurityIcon from "@mui/icons-material/Security";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import OutboxIcon from "@mui/icons-material/Outbox";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import BookmarkAddedIcon from "@mui/icons-material/BookmarkAdded";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import StoreIcon from "@mui/icons-material/Store";
import PaymentsIcon from "@mui/icons-material/Payments";
import ArticleIcon from "@mui/icons-material/Article";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import WalletIcon from "@mui/icons-material/Wallet";
import CategoryIcon from "@mui/icons-material/Category";
import SummarizeIcon from "@mui/icons-material/Summarize";
import TodayIcon from "@mui/icons-material/Today";
import PsychologyIcon from "@mui/icons-material/Psychology";

import Accesos from "../components/catalogos/accesos/FrmAccesos.jsx";
import Articulos from "../components/catalogos/articulos/Articulos.jsx";
import FrmAdministracionDispositivos from "../components/administracion/FrmAdministracionDispositivos.jsx";

export const dashboardPaginas = {
    Accesos: <Accesos />,
    Entradas: <Articulos />,
    AdministracionDispositivos: <FrmAdministracionDispositivos />,
};

export const menuModuloIcons = {
    seguridad: <SecurityIcon />,
    catalogo: <CategoryIcon />,
    articulo: <ArticleIcon />,
    addEventListenerccesos: <SecurityIcon />,
    todayIcon: <TodayIcon />,
    inteligencia_artificial: <PsychologyIcon />,
};

export const menuPaginaIcons = {
    elementos_sistema: <SummarizeIcon />,    
    administracion_dispositivos: <PhoneAndroidIcon />,
};

/* Accesos rápidos del dashboard central.
   Solo se declara el nombre de la página tal como existe en el esquema de accesos
   (menu + pagina). El path, la visibilidad (mostrar) y el bloqueo (status) se resuelven
   en runtime contra definicionMenu, por lo que si el usuario no tiene ese menú asignado
   el ícono no se renderiza. Ej.: "Centro de Costos" sólo aparece con el menú Administración. */
export const dashboardQuickAccess = [
    { pagina: "Entradas", Icon: MoveToInboxIcon },
    { pagina: "Salidas", Icon: OutboxIcon },
    { pagina: "Traslados A o H", Icon: SwapHorizIcon },
    { pagina: "Venta súper", Icon: PointOfSaleIcon },
    { pagina: "Preventas", Icon: BookmarkAddedIcon },
    { pagina: "Centro de Costos", Icon: AccountBalanceIcon },
    { pagina: "Accesos", Icon: AdminPanelSettingsIcon },
    { pagina: "Clientes", Icon: PeopleAltIcon },
    { pagina: "Compras", Icon: ShoppingCartIcon },
];
